export const isEmptyRichText = (value: string | undefined): boolean => {
  if (value === undefined || value === null) {
    return true
  }
  return value.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim().length === 0
}
